import { NgModule, Optional, SkipSelf } from '@angular/core'
import { akitaConfig, persistState } from '@datorama/akita'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { AppMaterialModule } from '@app/app-material.module'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { Router, RouterModule } from '@angular/router'
import { SessionService, SessionQuery } from '@app/core/state/session'
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component'
import { LoadingService } from './state/loading/loading.service'
import { LoadingInterceptor } from './interceptors/loading/loading.interceptor'
import { PERSIST_STORAGE } from './tokens/injection-tokens'
import { HeaderComponent } from './components/header/header.component'
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component'
import { NotificationService } from './services/notification.service'
import { NotificationComponent } from './components/notification/notification.component'
import { AuthInterceptor } from './interceptors/auth/auth.interceptor'

akitaConfig({ resettable: true })
const persistStorage = persistState({
  include: ['session.user'],
  key: 'Flexit Select user',
})

@NgModule({
  providers: [
    SessionService,
    SessionQuery,
    LoadingService,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true, deps: [SessionService, Router] },
    { provide: PERSIST_STORAGE, useValue: persistStorage },
    NotificationService,
  ],
  declarations: [LoadingBarComponent, HeaderComponent, BreadcrumbComponent, NotificationComponent],
  imports: [CommonModule, AppMaterialModule, ReactiveFormsModule, TranslateDirective, TranslatePipe, RouterModule],
  exports: [LoadingBarComponent, HeaderComponent],
})
export class CoreModule {
  /**
   * Ensure that CoreModule is imported only in AppModule
   */
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error(`${core.constructor.name} has already been loaded.`)
    }
  }
}
